import React from 'react'
import CannedBeansProduct from 'models/CannedBeansProduct'
import ProductForm from 'views/shared/ProductForm'
import CannedBeansPackage from './CannedBeansPackage'

const productOptions = {
  packagingInfo: <CannedBeansPackage />,
  productTitle: 'Canned Beans',
  model: CannedBeansProduct,
  validCategories: ['06'],
  validSubCategories: ['003'],
}

const CannedBeans = () => <ProductForm product={productOptions} />

export default CannedBeans

export const getCannedBeansPackage = newProduct => {
  const newCannedBeansPackage = {
    UPC: newProduct.UPC,
    LegumeProductType: 'Canned Mature Beans',
    SaltContent: newProduct.SaltContent,
    BeanPeaLentilType: null,
    BeanPeaLentilSize: null,
    PBType: null,
    PBTexture: null,
    PBContainerSize: newProduct.PBContainerSize,
  }
  return newCannedBeansPackage
}
export const updateCannedBeansPackage = newProduct => {
  const newCannedBeansPackage = {
    UPC: newProduct.UPC,
    LegumeProductType: 'Canned Mature Beans',
    BeanPeaLentilType: null,
    BeanPeaLentilSize: null,
    PBType: null,
    PBTexture: null,
    SaltContent: newProduct.SaltContent,
    PBContainerSize: newProduct.PBContainerSize,
  }
  return newCannedBeansPackage
}
